import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import colors from 'tailwindcss/colors';
import DonutChart from '../../dashboard/_charts/DonutChart';
import ChartLoader from '../../dashboard/_charts/ChartLoader';
import useEventEvaluationEducatorResponse, {
  ResponseFields,
  ResponseAnswers,
  ResponseAnswerMap
} from './_hooks/useEventEvaluationEducatorResponse';

export default function EventEvalResponseYear(props) {
  const { network, schoolStart, schoolEnd, subtitle, field = '', title = [] } = props;

  const responses = [
    ResponseAnswers.Significantly,
    ResponseAnswers.Somewhat,
    ResponseAnswers.NotAtAll,
    ResponseAnswers.NotAGoal,
    ResponseAnswers.NoAnswer
  ];

  const requests = responses.map(function(response) {
    const result = useEventEvaluationEducatorResponse({
      network,
      schoolStart,
      schoolEnd,
      responseField: field,
      responseAnswer: ResponseAnswerMap[response]
    });

    return {
      label: response,
      events: result
    };
  });

  const loading = _.reduce(requests, function(result, request) {
    return result || request.events.state === PayloadStates.FETCHING;
  }, false)

  if (loading) {
    return (
      <ChartLoader
        title={title}
        subtitle="For school year"
      />
    );
  }

  const series = requests.map(r => r.events.meta.totalCount);
  const labels = requests.map(r => r.label);

  return (
    <DonutChart
      title={title}
      subtitle="For school year"
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],
        colors.yellow['400'],
        colors.red['400'],
        colors.blue['400'],
        colors.purple['400']
      ]}
    />
  );
}
